import { api } from '../api/client';

export type ActiveUsersRange = '24h' | '7d' | '30d';

export interface ActiveUsersPoint {
  bucket: string;
  users: number;
}

export interface ActiveUsersResponse {
  range: ActiveUsersRange;
  label: string;
  activeUsers: number;
  trend: ActiveUsersPoint[];
  activeUserIds: string[];
}

class ActiveUsersService {
  async getActiveUsers(
    range: ActiveUsersRange = '24h'
  ): Promise<ActiveUsersResponse> {
    try {
      console.log('Calling Active Users API:', range);

      const response = await api.get<ActiveUsersResponse>(
        '/active-users',
        {
          params: {
            range,
          },
        }
      );

      console.log(
        'Active Users API response:',
        response.data
      );

      return response.data;
    } catch (error: any) {
      console.error('Active Users API error:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });

      throw new Error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        'Unable to load active users.'
      );
    }
  }
}

export const activeUsersService =
  new ActiveUsersService();

export default activeUsersService;